var map = {
	"./decidim/avatar-multiuser.png": 9970,
	"./decidim/brands/facebook.svg": 77412,
	"./decidim/brands/google.svg": 46717,
	"./decidim/brands/twitter-x.svg": 88494,
	"./decidim/cc-badge.png": 39436,
	"./decidim/decidim-logo.svg": 48960,
	"./decidim/default-avatar.svg": 27064,
	"./decidim/gamification/badges/decidim_gamification_badges_followers.svg": 17956,
	"./decidim/icons.svg": 38707,
	"./decidim/pattern.png": 40612,
	"./decidim/placeholder-card-g.svg": 9169,
	"./decidim/placeholder-card-l.svg": 72346,
	"./decidim/placeholder.jpg": 78985,
	"./decidim/remixicon.symbol.svg": 38589,
	"./decidim/vendor/social-share-button/douban.svg": 17196,
	"./decidim/vendor/social-share-button/email.svg": 98313,
	"./decidim/vendor/social-share-button/facebook.svg": 84383,
	"./decidim/vendor/social-share-button/google_bookmark.svg": 10401,
	"./decidim/vendor/social-share-button/hacker_news.svg": 28297,
	"./decidim/vendor/social-share-button/linkedin.svg": 86729,
	"./decidim/vendor/social-share-button/odnoklassniki.svg": 63754,
	"./decidim/vendor/social-share-button/pinterest.svg": 89583,
	"./decidim/vendor/social-share-button/reddit.svg": 61555,
	"./decidim/vendor/social-share-button/telegram.svg": 35142,
	"./decidim/vendor/social-share-button/tumblr.svg": 52741,
	"./decidim/vendor/social-share-button/twitter.svg": 57291,
	"./decidim/vendor/social-share-button/vkontakte.svg": 71286,
	"./decidim/vendor/social-share-button/wechat.svg": 55761,
	"./decidim/vendor/social-share-button/whatsapp.svg": 63993,
	"./decidim/vendor/social-share-button/x.svg": 96081,
	"./decidim/vendor/social-share-button/xing.svg": 87039
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 63412;